document.addEventListener('DOMContentLoaded', () => {
  const PredictiveSearchClass = customElements.get('predictive-search');
  if (!PredictiveSearchClass) return;

  PredictiveSearchClass.prototype._doPredictiveSearch = async function () {
    await this._transitionToSlot('loading');
    const fields = 'title,product_type,variants.title,vendor,variants.sku';
    const queryParams = `q=${encodeURIComponent(this._queryInput.value)}&section_id=${this.getAttribute('section-id')}&resources[limit]=10&resources[limit_scope]=each&resources[type]=product&resources[options][fields]=${fields}`;
    const response = await fetch(`${window.Shopify.routes.root}search/suggest?${queryParams}`, {
      signal: this._abortController.signal,
    });
    const nodeElement = new DOMParser().parseFromString(await response.text(), 'text/html');
    this.querySelector('[slot="results"]').replaceWith(
      document.importNode(nodeElement.querySelector('[slot="results"]'), true)
    );
    return this._transitionToSlot('results');
  };
});